/*
    Esses nomes devem ser iguais aos codigos dos exames persistidos no banco de dados
*/
module.exports = {
  EFICIENCIA_BALISTICA: 'EFICIENCIA_BALISTICA',
  CONFRONTO_BALISTICO: 'CONFRONTO_BALISTICO',
  COINCIDENCIA_PERFIS_BALISTICO: 'COINCIDENCIA_PERFIS_BALISTICO',
  INFO_TECNICA_SINAB: 'INFO_TECNICA_SINAB',
  IDENTIFICACAO_BALISTICA: 'IDENTIFICACAO_BALISTICA',
  NECROSCOPICO: 'NECROSCOPICO',
  PESQUISA_SANGUE_HUMANO: 'PESQUISA_SANGUE_HUMANO',
  TRAUMATOLOGICO: 'TRAUMATOLOGICO',
  CONSTATACAO: 'CONSTATACAO',
  QUIMICO_TOXICOLOGICO: 'QUIMICO_TOXICOLOGICO',
  DOSAGEM_ALCOOLICA: 'DOSAGEM_ALCOOLICA',
  IDENTIFICACAO_VEICULAR: 'IDENTIFICACAO_VEICULAR',
  VEICULAR: 'VEICULAR',
  TOXICOLOGICO_POST_MORTEM_DAF: 'TOXICOLOGICO_POST_MORTEM_DAF',
  TOXICOLOGICO_POST_MORTEM_PEST: 'TOXICOLOGICO_POST_MORTEM_PEST',
  TOXICOLOGICO_IN_VIVO: 'TOXICOLOGICO_IN_VIVO',
  TOXICOLOGICO_INVIVO_AGROTOXICO: 'TOXICOLOGICO_INVIVO_AGROTOXICO',
  TOXICOLOGICO_ALCOOLEMIA_VIVO: 'TOXICOLOGICO_ALCOOLEMIA_VIVO',
  TOXICOLOGICO_FARMACOS_DROGAS: 'TOXICOLOGICO_FARMACOS_DROGAS',
  TOXICOLOGIA_MATRIZES: 'TOXICOLOGIA_MATRIZES',
  CONJUNCAO_CARNAL: 'CONJUNCAO_CARNAL',
  ATO_LIBIDINOSO: 'ATO_LIBIDINOSO',
  PSICOLOGICA: 'PSICOLOGICA',
  LESAO_CORPORAL: 'LESAO_CORPORAL',
  ACHADO_CADAVER: 'ACHADO_CADAVER',
  TENTATIVA_HOMICIDIO: 'TENTATIVA_HOMICIDIO',
  IMOVEL: 'IMOVEL',
  TRAFEGO: 'TRAFEGO',
  ESPERMATOSOIDE_PSA: 'ESPERMATOSOIDE_PSA',
  RESIDUOGRAFICO: 'RESIDUOGRAFICO',
  DNA: 'DNA',
  QUIMICO_VOLATEIS: 'QUIMICO_VOLATEIS',
  QUIMICO_ANABOLIZANTES: 'QUIMICO_ANABOLIZANTES',
  QUIMICO_OUTRAS_SUBSTANCIAS: 'QUIMICO_OUTRAS_SUBSTANCIAS',
  DOCUMENTOSCOPICO: 'DOCUMENTOSCOPICO',
  OBJETO: 'OBJETO',
  COMPLEMENTAR: 'COMPLEMENTAR',
  PAPILOSCOPICO: 'PAPILOSCOPICO',
  CONFRONTO_PAPILOSCOPICO: 'CONFRONTO_PAPILOSCOPICO',
  GRAFOTÉCNICO: 'GRAFOTÉCNICO',
  ANTROPOLOGICO: 'ANTROPOLOGICO',
  AMBIENTAL: 'AMBIENTAL',
  MERCEOLOGICO: 'MERCEOLOGICO',
  INFORMATICA: 'INFORMATICA',
  INCENDIO: 'INCENDIO',
  AUDIO_VISUAL: 'AUDIO_VISUAL',
  CONTABIL: 'CONTABIL',
  ENGENHARIA_LEGAL: 'ENGENHARIA_LEGAL',
  CORPO_ESTRANHO: 'CORPO_ESTRANHO',
  GRAVIDEZ: 'GRAVIDEZ',
  MATERIAL_CAPILAR_HUMANO: 'MATERIAL_CAPILAR_HUMANO',
  TOXICOLOGICO_SOLVENTES_ORGANICOS: 'TOXICOLOGICO_SOLVENTES_ORGANICOS',
  NECROPAPILOSCOPIA: 'NECROPAPILOSCOPIA',
  IDENTIFICACAO_CADAVERICA: 'IDENTIFICACAO_CADAVERICA',
  CONFIRMACAO_IDENTIDADE: 'CONFIRMACAO_IDENTIDADE',
  IDENTIFICACAO_CRIMINAL: 'IDENTIFICACAO_CRIMINAL',
  IDENTIFICACAO_ODONTO: 'IDENTIFICACAO_ODONTO',
  MAUS_TRATOS: 'MAUS_TRATOS',
  QUIMICO_PESQUISA_AGROTOXICOS: 'QUIMICO_PESQUISA_AGROTOXICOS',
  QUIMICO_PESQUISA_SOLVENTES: 'QUIMICO_PESQUISA_SOLVENTES',
  QUIMICO_PRODUTO_FARMACEUTICO: 'QUIMICO_PRODUTO_FARMACEUTICO',
  QUIMICO_PESQUISA_INFLAMAVEIS: 'QUIMICO_PESQUISA_INFLAMAVEIS',
  QUIMICO_MATERIAL_DIVERSO: 'QUIMICO_MATERIAL_DIVERSO',
  PESQUISA_THC_COCAINA: 'PESQUISA_THC_COCAINA',
  IDENTIFICACAO_INFRACIONAL: 'IDENTIFICACAO_INFRACIONAL',
  QUIMICO_RESIDUOS_INCENDIO: 'QUIMICO_RESIDUOS_INCENDIO',
  NECRO_ODONTO: 'NECRO_ODONTO',
  CESSACAO_PERICULOSIDADE: 'CESSACAO_PERICULOSIDADE',
  //SUPERVENIENCIA_DOENCA_MENTAL: 'SUPERVENIENCIA_DOENCA_MENTAL', //verificar se este é o nome correto
}
